import {match} from 'ts-pattern';

import type {BulkOperationResponseBody} from '../../../types/api/bulkOperations';
import {isBulkOperationTerminal} from '../../../utils/isBulkOperationTerminal';

type BulkOperationSeverityInput = Pick<
  BulkOperationResponseBody,
  'state' | 'failedCount' | 'skippedCount'
>;

/** Red = any failure, orange = still running, cancelled or records skipped, green = finished clean. */
export function getBulkOperationSeverity(operation: BulkOperationSeverityInput) {
  return match(operation)
    .with({state: 'FAILED'}, {state: 'RESOLVE_FAILED'}, () => 'danger' as const)
    .when(
      (value) => value.failedCount > 0,
      () => 'danger' as const
    )
    .when(
      (value) => !isBulkOperationTerminal(value.state),
      () => 'warning' as const
    )
    .with({state: 'CANCELLED'}, () => 'warning' as const)
    .when(
      (value) => value.skippedCount > 0,
      () => 'warning' as const
    )
    .otherwise(() => 'success' as const);
}
